import { useFirebase } from "containers/FirebaseContext";
import {
  collection,
  deleteDoc,
  doc as firestoreDoc,
  getDoc,
  onSnapshot,
  query,
  setDoc,
  where,
} from "firebase/firestore";

export const useNotificationHistorias = () => {
  const { firestore } = useFirebase();

  const createCollectionSoyNotification = async (notificationData, classId) => {
    try {
      const generated_session_id =
        notificationData?.class_id + notificationData?.story_id;
      const docRef = firestoreDoc(
        firestore,
        "soy_historias_notification",
        generated_session_id
      );
      await setDoc(docRef, notificationData, { merge: true });
      return;
    } catch (error) {
      console.log(error, "error");
    }
  };

  const deleteCollectionSoyNotification = async (classId, storyId) => {
    try {
      const generated_session_id = classId + storyId;
      const docRef = firestoreDoc(
        firestore,
        "soy_historias_notification",
        generated_session_id
      );
      const docSnap = await getDoc(docRef);
      if (docSnap.exists()) {
        await deleteDoc(docRef);
        return true;
      } else {
        return false;
      }
    } catch (error) {
      console.error("Error deleting document:", error);
      throw error;
    }
  };

  const listenToNotificationSoyData = (classId, currentUserId, onDataChange, onError) => {
    if (!classId || !currentUserId) {
      console.warn("ClassId or currentUserId is missing for notification listener");
      return () => {}; // Return empty unsubscribe function
    }

    try {
      const collectionRef = collection(firestore, "soy_historias_notification");
      const q = query(
        collectionRef,
        where("createdBy", "!=", currentUserId),
        where("class_id", "==", classId)
      );

      const unsubscribe = onSnapshot(
        q,
        (querySnapshot) => {
          const notifications = [];
          querySnapshot.forEach((doc) => {
            notifications.push({ id: doc.id, ...doc.data() });
          });

          if (onDataChange) {
            onDataChange(notifications);
          }
        },
        (error) => {
          if (onError) {
            onError(error);
          }
        }
      );

      return unsubscribe;
    } catch (error) {
      if (onError) {
        onError(error);
      }
      return () => {};
    }
  };

  return { createCollectionSoyNotification,deleteCollectionSoyNotification, listenToNotificationSoyData };
};
